import { EntityService, GlobalService } from "app/core/services";
import { Observable } from "rxjs";
import { PrecargaSinDenuncia } from "../model/precargaSinDenuncia";
import { Injectable } from "@angular/core";

@Injectable()
export class PrecargaSinDenunciaService {
  constructor(
    private http: GlobalService,
    private entityService: EntityService
  ) { }

  getById(id: number): Observable<PrecargaSinDenuncia> {
    const url = `precargas-sin-denuncia/${id}`;
    return this.http
      .get(url)
      .map((res) => this.entityService.extractData<PrecargaSinDenuncia>(res))
      .map((dataItem) => this.entityService.copy(dataItem, new PrecargaSinDenuncia()));
  }

  getAll(): Observable<PrecargaSinDenuncia[]> {
    const url = `precargas-sin-denuncia`;
    return this.http
      .get(url)
      .map((res) => this.entityService.extractData<PrecargaSinDenuncia[]>(res))
      .map((data) => {
        return data.map((dataItem) => {
          const precarga = new PrecargaSinDenuncia();
          return this.entityService.copy(dataItem, precarga);
        });
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/precargaSinDenuncia.service.ts